import React from 'react'
import { isSubChallengesCompleted } from 'utils/challengesUtils'

interface IChallengeCheckProps {
	checked: boolean;
}

const ChallengeCheck = ({checked}: IChallengeCheckProps) => {
  return (
	<div className={`challenge-check ${checked ? 'challenge-check--completed': ''}`}>
		<span className="material-icons md-18">done</span>
	</div>
  )
}

export default ChallengeCheck